/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.1.0 (NJsonSchema v10.4.3.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export class ActivityAreaDto {
    idActivityArea?: number;
    idLanguage?: number;
    orderId?: number;
    title?: string;
    isControlledByStatus?: boolean;
    allowDateEnd?: boolean;
    allowDatePublication?: boolean;
    allowFileInCreateView?: boolean;
    hasLogTime?: boolean;
    icon?: string | undefined;
    metadataGroups?: number[];

    init(_data?: any) {
        if (_data) {
            this.idActivityArea = _data["idActivityArea"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            this.isControlledByStatus = _data["isControlledByStatus"];
            this.allowDateEnd = _data["allowDateEnd"];
            this.allowDatePublication = _data["allowDatePublication"];
            this.allowFileInCreateView = _data["allowFileInCreateView"];
            this.hasLogTime = _data["hasLogTime"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["metadataGroups"])) {
                this.metadataGroups = [] as any;
                for (let item of _data["metadataGroups"])
                    this.metadataGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityArea"] = this.idActivityArea;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        data["isControlledByStatus"] = this.isControlledByStatus;
        data["allowDateEnd"] = this.allowDateEnd;
        data["allowDatePublication"] = this.allowDatePublication;
        data["allowFileInCreateView"] = this.allowFileInCreateView;
        data["hasLogTime"] = this.hasLogTime;
        data["icon"] = this.icon;
        if (Array.isArray(this.metadataGroups)) {
            data["metadataGroups"] = [];
            for (let item of this.metadataGroups)
                data["metadataGroups"].push(item);
        }
        return data; 
    }

    clone(): ActivityAreaDto {
        const json = this.toJSON();
        let result = new ActivityAreaDto();
        result.init(json);
        return result;
    }
}

export class ActivityCommentDto {
    idActivity?: number;
    idActivityComment?: number;
    message?: string;
    isPublic?: number;
    idUser?: number;
    dateCreated?: string;
    user?: UserBadgeDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.idActivityComment = _data["idActivityComment"];
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
            this.idUser = _data["idUser"];
            this.dateCreated = _data["dateCreated"];
            this.user = _data["user"] ? UserBadgeDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["idActivityComment"] = this.idActivityComment;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        data["idUser"] = this.idUser;
        data["dateCreated"] = this.dateCreated;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ActivityCommentDto {
        const json = this.toJSON();
        let result = new ActivityCommentDto();
        result.init(json);
        return result;
    }
}

export class UserBadgeDto {
    idUser?: number;
    name?: string;
    photo?: string;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.name = _data["name"];
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): UserBadgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserBadgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["name"] = this.name;
        data["photo"] = this.photo;
        return data; 
    }

    clone(): UserBadgeDto {
        const json = this.toJSON();
        let result = new UserBadgeDto();
        result.init(json);
        return result;
    }
}

export class ActivityDto {
    idActivity?: number;
    idLanguage?: number;
    idActivityArea?: number | undefined;
    activityArea?: ActivityAreaDto | undefined;
    idActivityType?: number | undefined;
    activityType?: ActivityTypeDto | undefined;
    idActivityStatus?: number | undefined;
    activityStatus?: ActivityStatusDto | undefined;
    idActivityPriority?: number | undefined;
    activityPriority?: ActivityPriorityDto | undefined;
    title?: string;
    description?: string | undefined;
    idEntity?: number | undefined;
    entity?: Entity | undefined;
    dateStart?: string;
    dateEnd?: string | undefined;
    dateCompleted?: string | undefined;
    datePublication?: string | undefined;
    dateCreated?: string;
    owner?: UserBadgeDto;
    assignees?: UserBadgeDto[];
    appGroups?: AppGroup[];
    tags?: ActivityTagDto[];
    files?: ActivityFileDto[];
    logtimes?: ActivityLogtimeDto[];
    isPrivate?: boolean;
    isFeatured?: boolean;
    isPublished?: boolean;
    metadata?: MetadataConfigurationFieldSimple[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.idLanguage = _data["idLanguage"];
            this.idActivityArea = _data["idActivityArea"];
            this.activityArea = _data["activityArea"] ? ActivityAreaDto.fromJS(_data["activityArea"]) : <any>undefined;
            this.idActivityType = _data["idActivityType"];
            this.activityType = _data["activityType"] ? ActivityTypeDto.fromJS(_data["activityType"]) : <any>undefined;
            this.idActivityStatus = _data["idActivityStatus"];
            this.activityStatus = _data["activityStatus"] ? ActivityStatusDto.fromJS(_data["activityStatus"]) : <any>undefined;
            this.idActivityPriority = _data["idActivityPriority"];
            this.activityPriority = _data["activityPriority"] ? ActivityPriorityDto.fromJS(_data["activityPriority"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.dateCompleted = _data["dateCompleted"];
            this.datePublication = _data["datePublication"];
            this.dateCreated = _data["dateCreated"];
            this.owner = _data["owner"] ? UserBadgeDto.fromJS(_data["owner"]) : <any>undefined;
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(UserBadgeDto.fromJS(item));
            }
            if (Array.isArray(_data["appGroups"])) {
                this.appGroups = [] as any;
                for (let item of _data["appGroups"])
                    this.appGroups!.push(AppGroup.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ActivityTagDto.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ActivityFileDto.fromJS(item));
            }
            if (Array.isArray(_data["logtimes"])) {
                this.logtimes = [] as any;
                for (let item of _data["logtimes"])
                    this.logtimes!.push(ActivityLogtimeDto.fromJS(item));
            }
            this.isPrivate = _data["isPrivate"];
            this.isFeatured = _data["isFeatured"];
            this.isPublished = _data["isPublished"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["idLanguage"] = this.idLanguage;
        data["idActivityArea"] = this.idActivityArea;
        data["activityArea"] = this.activityArea ? this.activityArea.toJSON() : <any>undefined;
        data["idActivityType"] = this.idActivityType;
        data["activityType"] = this.activityType ? this.activityType.toJSON() : <any>undefined;
        data["idActivityStatus"] = this.idActivityStatus;
        data["activityStatus"] = this.activityStatus ? this.activityStatus.toJSON() : <any>undefined;
        data["idActivityPriority"] = this.idActivityPriority;
        data["activityPriority"] = this.activityPriority ? this.activityPriority.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["dateCompleted"] = this.dateCompleted;
        data["datePublication"] = this.datePublication;
        data["dateCreated"] = this.dateCreated;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item.toJSON());
        }
        if (Array.isArray(this.appGroups)) {
            data["appGroups"] = [];
            for (let item of this.appGroups)
                data["appGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.logtimes)) {
            data["logtimes"] = [];
            for (let item of this.logtimes)
                data["logtimes"].push(item.toJSON());
        }
        data["isPrivate"] = this.isPrivate;
        data["isFeatured"] = this.isFeatured;
        data["isPublished"] = this.isPublished;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ActivityDto {
        const json = this.toJSON();
        let result = new ActivityDto();
        result.init(json);
        return result;
    }
}

export class ActivityTypeDto {
    idActivityType?: number;
    idActivityArea?: number;
    idLanguage?: number;
    orderId?: number;
    title?: string;
    color?: string;

    init(_data?: any) {
        if (_data) {
            this.idActivityType = _data["idActivityType"];
            this.idActivityArea = _data["idActivityArea"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActivityTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityType"] = this.idActivityType;
        data["idActivityArea"] = this.idActivityArea;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        data["color"] = this.color;
        return data; 
    }

    clone(): ActivityTypeDto {
        const json = this.toJSON();
        let result = new ActivityTypeDto();
        result.init(json);
        return result;
    }
}

export class ActivityStatusDto {
    idActivityStatus?: number;
    idLanguage?: number;
    orderId?: number;
    idActivityArea?: number;
    title?: string;
    isFinal?: boolean;
    isSuccess?: boolean;
    color?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.idActivityStatus = _data["idActivityStatus"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.idActivityArea = _data["idActivityArea"];
            this.title = _data["title"];
            this.isFinal = _data["isFinal"];
            this.isSuccess = _data["isSuccess"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActivityStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityStatus"] = this.idActivityStatus;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["idActivityArea"] = this.idActivityArea;
        data["title"] = this.title;
        data["isFinal"] = this.isFinal;
        data["isSuccess"] = this.isSuccess;
        data["color"] = this.color;
        return data; 
    }

    clone(): ActivityStatusDto {
        const json = this.toJSON();
        let result = new ActivityStatusDto();
        result.init(json);
        return result;
    }
}

export class ActivityPriorityDto {
    idActivityPriority?: number;
    idLanguage?: number;
    orderId?: number;
    title?: string;
    color?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.idActivityPriority = _data["idActivityPriority"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActivityPriorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPriorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityPriority"] = this.idActivityPriority;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        data["color"] = this.color;
        return data; 
    }

    clone(): ActivityPriorityDto {
        const json = this.toJSON();
        let result = new ActivityPriorityDto();
        result.init(json);
        return result;
    }
}

export abstract class AuditableEntity {
    createdBy?: string | undefined;
    dateCreated?: string;
    lastModifiedBy?: string | undefined;
    dateUpdated?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.dateCreated = _data["dateCreated"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.dateUpdated = _data["dateUpdated"];
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["dateCreated"] = this.dateCreated;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["dateUpdated"] = this.dateUpdated;
        return data; 
    }

    clone(): AuditableEntity {
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }
}

export abstract class OwnerEntity extends AuditableEntity {
    idOwner?: number | undefined;
    owner?: User | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idOwner = _data["idOwner"];
            this.owner = _data["owner"] ? User.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OwnerEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OwnerEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idOwner"] = this.idOwner;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): OwnerEntity {
        throw new Error("The abstract class 'OwnerEntity' cannot be instantiated.");
    }
}

export class Entity extends OwnerEntity {
    idEntity?: number;
    name?: string;
    fiscalIdNumber?: string;
    website?: string | undefined;
    notes?: string | undefined;
    photo?: string | undefined;
    isCompany?: boolean;
    idEntityGroup?: number | undefined;
    entityGroup?: EntityGroup | undefined;
    idEntityType?: number | undefined;
    entityType?: EntityType | undefined;
    files?: EntityFile[];
    users?: User[];
    comments?: EntityComment[];
    logs?: EntityLog[];
    entityMetadata?: EntityMetadata[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.name = _data["name"];
            this.fiscalIdNumber = _data["fiscalIdNumber"];
            this.website = _data["website"];
            this.notes = _data["notes"];
            this.photo = _data["photo"];
            this.isCompany = _data["isCompany"];
            this.idEntityGroup = _data["idEntityGroup"];
            this.entityGroup = _data["entityGroup"] ? EntityGroup.fromJS(_data["entityGroup"]) : <any>undefined;
            this.idEntityType = _data["idEntityType"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(EntityFile.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(EntityComment.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(EntityLog.fromJS(item));
            }
            if (Array.isArray(_data["entityMetadata"])) {
                this.entityMetadata = [] as any;
                for (let item of _data["entityMetadata"])
                    this.entityMetadata!.push(EntityMetadata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        let result = new Entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["name"] = this.name;
        data["fiscalIdNumber"] = this.fiscalIdNumber;
        data["website"] = this.website;
        data["notes"] = this.notes;
        data["photo"] = this.photo;
        data["isCompany"] = this.isCompany;
        data["idEntityGroup"] = this.idEntityGroup;
        data["entityGroup"] = this.entityGroup ? this.entityGroup.toJSON() : <any>undefined;
        data["idEntityType"] = this.idEntityType;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        if (Array.isArray(this.entityMetadata)) {
            data["entityMetadata"] = [];
            for (let item of this.entityMetadata)
                data["entityMetadata"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Entity {
        const json = this.toJSON();
        let result = new Entity();
        result.init(json);
        return result;
    }
}

export class EntityGroup extends AuditableEntity {
    idEntityGroup?: number;
    entityGroupAttrs?: EntityGroupAttr[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityGroup = _data["idEntityGroup"];
            if (Array.isArray(_data["entityGroupAttrs"])) {
                this.entityGroupAttrs = [] as any;
                for (let item of _data["entityGroupAttrs"])
                    this.entityGroupAttrs!.push(EntityGroupAttr.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EntityGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityGroup"] = this.idEntityGroup;
        if (Array.isArray(this.entityGroupAttrs)) {
            data["entityGroupAttrs"] = [];
            for (let item of this.entityGroupAttrs)
                data["entityGroupAttrs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EntityGroup {
        const json = this.toJSON();
        let result = new EntityGroup();
        result.init(json);
        return result;
    }
}

export class EntityGroupAttr {
    idEntityGroup?: number;
    entityGroup?: EntityGroup;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idEntityGroup = _data["idEntityGroup"];
            this.entityGroup = _data["entityGroup"] ? EntityGroup.fromJS(_data["entityGroup"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityGroupAttr {
        data = typeof data === 'object' ? data : {};
        let result = new EntityGroupAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityGroup"] = this.idEntityGroup;
        data["entityGroup"] = this.entityGroup ? this.entityGroup.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntityGroupAttr {
        const json = this.toJSON();
        let result = new EntityGroupAttr();
        result.init(json);
        return result;
    }
}

export class Language extends AuditableEntity {
    idLanguage?: number;
    name?: string;
    reference?: string;
    code?: string;
    direction?: string;
    isDefault?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.code = _data["code"];
            this.direction = _data["direction"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["code"] = this.code;
        data["direction"] = this.direction;
        data["isDefault"] = this.isDefault;
        super.toJSON(data);
        return data; 
    }

    clone(): Language {
        const json = this.toJSON();
        let result = new Language();
        result.init(json);
        return result;
    }
}

export class EntityType extends AuditableEntity {
    idEntityType?: number;
    orderId?: number;
    entityTypeAttrs?: EntityTypeAttr[];
    entityTypeVsMetadataGroups?: EntityTypeVsMetadataGroup[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityType = _data["idEntityType"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["entityTypeAttrs"])) {
                this.entityTypeAttrs = [] as any;
                for (let item of _data["entityTypeAttrs"])
                    this.entityTypeAttrs!.push(EntityTypeAttr.fromJS(item));
            }
            if (Array.isArray(_data["entityTypeVsMetadataGroups"])) {
                this.entityTypeVsMetadataGroups = [] as any;
                for (let item of _data["entityTypeVsMetadataGroups"])
                    this.entityTypeVsMetadataGroups!.push(EntityTypeVsMetadataGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityType {
        data = typeof data === 'object' ? data : {};
        let result = new EntityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityType"] = this.idEntityType;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.entityTypeAttrs)) {
            data["entityTypeAttrs"] = [];
            for (let item of this.entityTypeAttrs)
                data["entityTypeAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.entityTypeVsMetadataGroups)) {
            data["entityTypeVsMetadataGroups"] = [];
            for (let item of this.entityTypeVsMetadataGroups)
                data["entityTypeVsMetadataGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EntityType {
        const json = this.toJSON();
        let result = new EntityType();
        result.init(json);
        return result;
    }
}

export class EntityTypeAttr {
    idEntityType?: number;
    entityType?: EntityType;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idEntityType = _data["idEntityType"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityTypeAttr {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityType"] = this.idEntityType;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntityTypeAttr {
        const json = this.toJSON();
        let result = new EntityTypeAttr();
        result.init(json);
        return result;
    }
}

export class EntityTypeVsMetadataGroup extends AuditableEntity {
    idMetadataGroup?: number;
    metadataGroup?: MetadataGroup;
    idEntityType?: number;
    entityType?: EntityType;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.metadataGroup = _data["metadataGroup"] ? MetadataGroup.fromJS(_data["metadataGroup"]) : <any>undefined;
            this.idEntityType = _data["idEntityType"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityTypeVsMetadataGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeVsMetadataGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["metadataGroup"] = this.metadataGroup ? this.metadataGroup.toJSON() : <any>undefined;
        data["idEntityType"] = this.idEntityType;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): EntityTypeVsMetadataGroup {
        const json = this.toJSON();
        let result = new EntityTypeVsMetadataGroup();
        result.init(json);
        return result;
    }
}

export class MetadataGroup extends AuditableEntity {
    idMetadataGroup?: number;
    orderId?: number;
    visibleOnCreate?: boolean;
    metadataGroupAttrs?: MetadataGroupAttr[];
    metadataFields?: MetadataField[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.orderId = _data["orderId"];
            this.visibleOnCreate = _data["visibleOnCreate"];
            if (Array.isArray(_data["metadataGroupAttrs"])) {
                this.metadataGroupAttrs = [] as any;
                for (let item of _data["metadataGroupAttrs"])
                    this.metadataGroupAttrs!.push(MetadataGroupAttr.fromJS(item));
            }
            if (Array.isArray(_data["metadataFields"])) {
                this.metadataFields = [] as any;
                for (let item of _data["metadataFields"])
                    this.metadataFields!.push(MetadataField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataGroup {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["orderId"] = this.orderId;
        data["visibleOnCreate"] = this.visibleOnCreate;
        if (Array.isArray(this.metadataGroupAttrs)) {
            data["metadataGroupAttrs"] = [];
            for (let item of this.metadataGroupAttrs)
                data["metadataGroupAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.metadataFields)) {
            data["metadataFields"] = [];
            for (let item of this.metadataFields)
                data["metadataFields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): MetadataGroup {
        const json = this.toJSON();
        let result = new MetadataGroup();
        result.init(json);
        return result;
    }
}

export class MetadataGroupAttr {
    idMetadataGroup?: number;
    metadataGroup?: MetadataGroup;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.metadataGroup = _data["metadataGroup"] ? MetadataGroup.fromJS(_data["metadataGroup"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MetadataGroupAttr {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataGroupAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["metadataGroup"] = this.metadataGroup ? this.metadataGroup.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): MetadataGroupAttr {
        const json = this.toJSON();
        let result = new MetadataGroupAttr();
        result.init(json);
        return result;
    }
}

export class MetadataField extends AuditableEntity {
    idMetadataField?: number;
    idMetadataGroup?: number;
    metadataGroup?: MetadataGroup;
    orderId?: number;
    reference?: string;
    default?: string | undefined;
    photo?: string | undefined;
    validation?: string | undefined;
    isRequired?: boolean;
    typeId?: MetadataFieldTypes;
    metadataFieldAttrs?: MetadataFieldAttr[];
    metadataFieldOptions?: MetadataFieldOption[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.metadataGroup = _data["metadataGroup"] ? MetadataGroup.fromJS(_data["metadataGroup"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.reference = _data["reference"];
            this.default = _data["default"];
            this.photo = _data["photo"];
            this.validation = _data["validation"];
            this.isRequired = _data["isRequired"];
            this.typeId = _data["typeId"];
            if (Array.isArray(_data["metadataFieldAttrs"])) {
                this.metadataFieldAttrs = [] as any;
                for (let item of _data["metadataFieldAttrs"])
                    this.metadataFieldAttrs!.push(MetadataFieldAttr.fromJS(item));
            }
            if (Array.isArray(_data["metadataFieldOptions"])) {
                this.metadataFieldOptions = [] as any;
                for (let item of _data["metadataFieldOptions"])
                    this.metadataFieldOptions!.push(MetadataFieldOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataField {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["metadataGroup"] = this.metadataGroup ? this.metadataGroup.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["reference"] = this.reference;
        data["default"] = this.default;
        data["photo"] = this.photo;
        data["validation"] = this.validation;
        data["isRequired"] = this.isRequired;
        data["typeId"] = this.typeId;
        if (Array.isArray(this.metadataFieldAttrs)) {
            data["metadataFieldAttrs"] = [];
            for (let item of this.metadataFieldAttrs)
                data["metadataFieldAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.metadataFieldOptions)) {
            data["metadataFieldOptions"] = [];
            for (let item of this.metadataFieldOptions)
                data["metadataFieldOptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): MetadataField {
        const json = this.toJSON();
        let result = new MetadataField();
        result.init(json);
        return result;
    }
}

export enum MetadataFieldTypes {
    Text = 1,
    Html = 2,
    Date = 3,
    Time = 4,
    Datetime = 5,
    Integer = 6,
    Decimal = 7,
    Currency = 8,
    GpsCoordinates = 9,
    SelectorSingle = 10,
    SelectorMultiple = 11,
    File = 12,
    Boolean = 13,
}

export class MetadataFieldAttr {
    idMetadataField?: number;
    metadataField?: MetadataField;
    idLanguage?: number;
    language?: Language;
    title?: string;
    description?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.metadataField = _data["metadataField"] ? MetadataField.fromJS(_data["metadataField"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MetadataFieldAttr {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["metadataField"] = this.metadataField ? this.metadataField.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        return data; 
    }

    clone(): MetadataFieldAttr {
        const json = this.toJSON();
        let result = new MetadataFieldAttr();
        result.init(json);
        return result;
    }
}

export class MetadataFieldOption extends AuditableEntity {
    idMetadataFieldOption?: number;
    idMetadataField?: number;
    metadataField?: MetadataField;
    orderId?: number;
    photo?: string | undefined;
    metadataFieldOptionAttrs?: MetadataFieldOptionAttr[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.idMetadataField = _data["idMetadataField"];
            this.metadataField = _data["metadataField"] ? MetadataField.fromJS(_data["metadataField"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.photo = _data["photo"];
            if (Array.isArray(_data["metadataFieldOptionAttrs"])) {
                this.metadataFieldOptionAttrs = [] as any;
                for (let item of _data["metadataFieldOptionAttrs"])
                    this.metadataFieldOptionAttrs!.push(MetadataFieldOptionAttr.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataFieldOption {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["idMetadataField"] = this.idMetadataField;
        data["metadataField"] = this.metadataField ? this.metadataField.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["photo"] = this.photo;
        if (Array.isArray(this.metadataFieldOptionAttrs)) {
            data["metadataFieldOptionAttrs"] = [];
            for (let item of this.metadataFieldOptionAttrs)
                data["metadataFieldOptionAttrs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): MetadataFieldOption {
        const json = this.toJSON();
        let result = new MetadataFieldOption();
        result.init(json);
        return result;
    }
}

export class MetadataFieldOptionAttr {
    idMetadataFieldOption?: number;
    metadataFieldOption?: MetadataFieldOption;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.metadataFieldOption = _data["metadataFieldOption"] ? MetadataFieldOption.fromJS(_data["metadataFieldOption"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MetadataFieldOptionAttr {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldOptionAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["metadataFieldOption"] = this.metadataFieldOption ? this.metadataFieldOption.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): MetadataFieldOptionAttr {
        const json = this.toJSON();
        let result = new MetadataFieldOptionAttr();
        result.init(json);
        return result;
    }
}

export class EntityFile extends AuditableEntity {
    idEntityFile?: number;
    idEntity?: number | undefined;
    entity?: Entity | undefined;
    idUser?: number | undefined;
    user?: User | undefined;
    filename?: string;
    isPublic?: boolean;
    title?: string;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityFile = _data["idEntityFile"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.filename = _data["filename"];
            this.isPublic = _data["isPublic"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityFile {
        data = typeof data === 'object' ? data : {};
        let result = new EntityFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityFile"] = this.idEntityFile;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["filename"] = this.filename;
        data["isPublic"] = this.isPublic;
        data["title"] = this.title;
        super.toJSON(data);
        return data; 
    }

    clone(): EntityFile {
        const json = this.toJSON();
        let result = new EntityFile();
        result.init(json);
        return result;
    }
}

export class User extends OwnerEntity {
    idUser?: number;
    name?: string;
    email?: string | undefined;
    contactDefault?: string | undefined;
    contactOptional?: string | undefined;
    idParent?: number | undefined;
    parent?: User | undefined;
    idUserType?: number | undefined;
    userType?: UserType | undefined;
    idEntity?: number | undefined;
    entity?: Entity | undefined;
    path?: string | undefined;
    photo?: string | undefined;
    nationality?: string | undefined;
    dateBirth?: string | undefined;
    appGroups?: UserVsAppGroup[];
    descendents?: User[];
    userLogins?: UserLogin[];
    userMetadata?: UserMetadata[];
    comments?: UserComment[];
    logs?: UserLog[];
    feedbacks?: Feedback[];
    concludedFeedbacks?: FeedbackVsUser[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUser = _data["idUser"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.contactDefault = _data["contactDefault"];
            this.contactOptional = _data["contactOptional"];
            this.idParent = _data["idParent"];
            this.parent = _data["parent"] ? User.fromJS(_data["parent"]) : <any>undefined;
            this.idUserType = _data["idUserType"];
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : <any>undefined;
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.path = _data["path"];
            this.photo = _data["photo"];
            this.nationality = _data["nationality"];
            this.dateBirth = _data["dateBirth"];
            if (Array.isArray(_data["appGroups"])) {
                this.appGroups = [] as any;
                for (let item of _data["appGroups"])
                    this.appGroups!.push(UserVsAppGroup.fromJS(item));
            }
            if (Array.isArray(_data["descendents"])) {
                this.descendents = [] as any;
                for (let item of _data["descendents"])
                    this.descendents!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["userLogins"])) {
                this.userLogins = [] as any;
                for (let item of _data["userLogins"])
                    this.userLogins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["userMetadata"])) {
                this.userMetadata = [] as any;
                for (let item of _data["userMetadata"])
                    this.userMetadata!.push(UserMetadata.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(UserComment.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(UserLog.fromJS(item));
            }
            if (Array.isArray(_data["feedbacks"])) {
                this.feedbacks = [] as any;
                for (let item of _data["feedbacks"])
                    this.feedbacks!.push(Feedback.fromJS(item));
            }
            if (Array.isArray(_data["concludedFeedbacks"])) {
                this.concludedFeedbacks = [] as any;
                for (let item of _data["concludedFeedbacks"])
                    this.concludedFeedbacks!.push(FeedbackVsUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["name"] = this.name;
        data["email"] = this.email;
        data["contactDefault"] = this.contactDefault;
        data["contactOptional"] = this.contactOptional;
        data["idParent"] = this.idParent;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["idUserType"] = this.idUserType;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>undefined;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["path"] = this.path;
        data["photo"] = this.photo;
        data["nationality"] = this.nationality;
        data["dateBirth"] = this.dateBirth;
        if (Array.isArray(this.appGroups)) {
            data["appGroups"] = [];
            for (let item of this.appGroups)
                data["appGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.descendents)) {
            data["descendents"] = [];
            for (let item of this.descendents)
                data["descendents"].push(item.toJSON());
        }
        if (Array.isArray(this.userLogins)) {
            data["userLogins"] = [];
            for (let item of this.userLogins)
                data["userLogins"].push(item.toJSON());
        }
        if (Array.isArray(this.userMetadata)) {
            data["userMetadata"] = [];
            for (let item of this.userMetadata)
                data["userMetadata"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbacks)) {
            data["feedbacks"] = [];
            for (let item of this.feedbacks)
                data["feedbacks"].push(item.toJSON());
        }
        if (Array.isArray(this.concludedFeedbacks)) {
            data["concludedFeedbacks"] = [];
            for (let item of this.concludedFeedbacks)
                data["concludedFeedbacks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export class UserType extends AuditableEntity {
    idUserType?: number;
    orderId?: number;
    userTypeAttrs?: UserTypeAttr[];
    userTypeVsMetadataGroups?: UserTypeVsMetadataGroup[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserType = _data["idUserType"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["userTypeAttrs"])) {
                this.userTypeAttrs = [] as any;
                for (let item of _data["userTypeAttrs"])
                    this.userTypeAttrs!.push(UserTypeAttr.fromJS(item));
            }
            if (Array.isArray(_data["userTypeVsMetadataGroups"])) {
                this.userTypeVsMetadataGroups = [] as any;
                for (let item of _data["userTypeVsMetadataGroups"])
                    this.userTypeVsMetadataGroups!.push(UserTypeVsMetadataGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserType {
        data = typeof data === 'object' ? data : {};
        let result = new UserType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserType"] = this.idUserType;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.userTypeAttrs)) {
            data["userTypeAttrs"] = [];
            for (let item of this.userTypeAttrs)
                data["userTypeAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.userTypeVsMetadataGroups)) {
            data["userTypeVsMetadataGroups"] = [];
            for (let item of this.userTypeVsMetadataGroups)
                data["userTypeVsMetadataGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): UserType {
        const json = this.toJSON();
        let result = new UserType();
        result.init(json);
        return result;
    }
}

export class UserTypeAttr {
    idUserType?: number;
    userType?: UserType;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idUserType = _data["idUserType"];
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UserTypeAttr {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserType"] = this.idUserType;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): UserTypeAttr {
        const json = this.toJSON();
        let result = new UserTypeAttr();
        result.init(json);
        return result;
    }
}

export class UserTypeVsMetadataGroup extends AuditableEntity {
    idMetadataGroup?: number;
    metadataGroup?: MetadataGroup;
    idUserType?: number;
    userType?: UserType;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.metadataGroup = _data["metadataGroup"] ? MetadataGroup.fromJS(_data["metadataGroup"]) : <any>undefined;
            this.idUserType = _data["idUserType"];
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserTypeVsMetadataGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeVsMetadataGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["metadataGroup"] = this.metadataGroup ? this.metadataGroup.toJSON() : <any>undefined;
        data["idUserType"] = this.idUserType;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserTypeVsMetadataGroup {
        const json = this.toJSON();
        let result = new UserTypeVsMetadataGroup();
        result.init(json);
        return result;
    }
}

export class UserVsAppGroup extends AuditableEntity {
    idUser?: number;
    user?: User;
    idAppGroup?: number;
    appGroup?: AppGroup;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.idAppGroup = _data["idAppGroup"];
            this.appGroup = _data["appGroup"] ? AppGroup.fromJS(_data["appGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserVsAppGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserVsAppGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["idAppGroup"] = this.idAppGroup;
        data["appGroup"] = this.appGroup ? this.appGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserVsAppGroup {
        const json = this.toJSON();
        let result = new UserVsAppGroup();
        result.init(json);
        return result;
    }
}

export class AppGroup extends AuditableEntity {
    idAppGroup?: number;
    name?: string;
    orderId?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppGroup = _data["idAppGroup"];
            this.name = _data["name"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): AppGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AppGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppGroup"] = this.idAppGroup;
        data["name"] = this.name;
        data["orderId"] = this.orderId;
        super.toJSON(data);
        return data; 
    }

    clone(): AppGroup {
        const json = this.toJSON();
        let result = new AppGroup();
        result.init(json);
        return result;
    }
}

export class UserLogin extends AuditableEntity {
    idUserLogin?: number;
    username?: string;
    password?: string;
    passwordSalt?: string;
    passwordRecoverToken?: string | undefined;
    passwordRecoverDate?: string | undefined;
    userLoginVsAppGroups?: UserLoginVsAppGroup[];
    userLoginAccesses?: UserLoginAccess[];
    idUser?: number;
    user?: User;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLogin = _data["idUserLogin"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.passwordSalt = _data["passwordSalt"];
            this.passwordRecoverToken = _data["passwordRecoverToken"];
            this.passwordRecoverDate = _data["passwordRecoverDate"];
            if (Array.isArray(_data["userLoginVsAppGroups"])) {
                this.userLoginVsAppGroups = [] as any;
                for (let item of _data["userLoginVsAppGroups"])
                    this.userLoginVsAppGroups!.push(UserLoginVsAppGroup.fromJS(item));
            }
            if (Array.isArray(_data["userLoginAccesses"])) {
                this.userLoginAccesses = [] as any;
                for (let item of _data["userLoginAccesses"])
                    this.userLoginAccesses!.push(UserLoginAccess.fromJS(item));
            }
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLogin"] = this.idUserLogin;
        data["username"] = this.username;
        data["password"] = this.password;
        data["passwordSalt"] = this.passwordSalt;
        data["passwordRecoverToken"] = this.passwordRecoverToken;
        data["passwordRecoverDate"] = this.passwordRecoverDate;
        if (Array.isArray(this.userLoginVsAppGroups)) {
            data["userLoginVsAppGroups"] = [];
            for (let item of this.userLoginVsAppGroups)
                data["userLoginVsAppGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.userLoginAccesses)) {
            data["userLoginAccesses"] = [];
            for (let item of this.userLoginAccesses)
                data["userLoginAccesses"].push(item.toJSON());
        }
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export class UserLoginVsAppGroup extends AuditableEntity {
    idUserLogin?: number;
    userLogin?: UserLogin;
    idAppGroup?: number;
    appGroup?: AppGroup;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLogin = _data["idUserLogin"];
            this.userLogin = _data["userLogin"] ? UserLogin.fromJS(_data["userLogin"]) : <any>undefined;
            this.idAppGroup = _data["idAppGroup"];
            this.appGroup = _data["appGroup"] ? AppGroup.fromJS(_data["appGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginVsAppGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginVsAppGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLogin"] = this.idUserLogin;
        data["userLogin"] = this.userLogin ? this.userLogin.toJSON() : <any>undefined;
        data["idAppGroup"] = this.idAppGroup;
        data["appGroup"] = this.appGroup ? this.appGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLoginVsAppGroup {
        const json = this.toJSON();
        let result = new UserLoginVsAppGroup();
        result.init(json);
        return result;
    }
}

export class UserLoginAccess extends AuditableEntity {
    idUserLogin?: number;
    userLogin?: UserLogin;
    idAppInterfaceRole?: number;
    appInterfaceRole?: AppInterfaceRole;
    isActive?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLogin = _data["idUserLogin"];
            this.userLogin = _data["userLogin"] ? UserLogin.fromJS(_data["userLogin"]) : <any>undefined;
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.appInterfaceRole = _data["appInterfaceRole"] ? AppInterfaceRole.fromJS(_data["appInterfaceRole"]) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserLoginAccess {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLogin"] = this.idUserLogin;
        data["userLogin"] = this.userLogin ? this.userLogin.toJSON() : <any>undefined;
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["appInterfaceRole"] = this.appInterfaceRole ? this.appInterfaceRole.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLoginAccess {
        const json = this.toJSON();
        let result = new UserLoginAccess();
        result.init(json);
        return result;
    }
}

export class AppInterfaceRole extends AuditableEntity {
    idAppInterfaceRole?: number;
    idAppInterface?: number;
    appInterface?: AppInterface;
    canImportOrExport?: boolean;
    appInterfaceRoleAttrs?: AppInterfaceRoleAttr[];
    permissions?: AppInterfaceRoleVsAppInterfaceModule[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.idAppInterface = _data["idAppInterface"];
            this.appInterface = _data["appInterface"] ? AppInterface.fromJS(_data["appInterface"]) : <any>undefined;
            this.canImportOrExport = _data["canImportOrExport"];
            if (Array.isArray(_data["appInterfaceRoleAttrs"])) {
                this.appInterfaceRoleAttrs = [] as any;
                for (let item of _data["appInterfaceRoleAttrs"])
                    this.appInterfaceRoleAttrs!.push(AppInterfaceRoleAttr.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(AppInterfaceRoleVsAppInterfaceModule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppInterfaceRole {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["idAppInterface"] = this.idAppInterface;
        data["appInterface"] = this.appInterface ? this.appInterface.toJSON() : <any>undefined;
        data["canImportOrExport"] = this.canImportOrExport;
        if (Array.isArray(this.appInterfaceRoleAttrs)) {
            data["appInterfaceRoleAttrs"] = [];
            for (let item of this.appInterfaceRoleAttrs)
                data["appInterfaceRoleAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): AppInterfaceRole {
        const json = this.toJSON();
        let result = new AppInterfaceRole();
        result.init(json);
        return result;
    }
}

export class AppInterface extends AuditableEntity {
    idAppInterface?: number;
    name?: string;
    website?: string;
    isActive?: boolean;
    appInterfaceRoles?: AppInterfaceRole[];
    appInterfaceModules?: AppInterfaceModule[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterface = _data["idAppInterface"];
            this.name = _data["name"];
            this.website = _data["website"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["appInterfaceRoles"])) {
                this.appInterfaceRoles = [] as any;
                for (let item of _data["appInterfaceRoles"])
                    this.appInterfaceRoles!.push(AppInterfaceRole.fromJS(item));
            }
            if (Array.isArray(_data["appInterfaceModules"])) {
                this.appInterfaceModules = [] as any;
                for (let item of _data["appInterfaceModules"])
                    this.appInterfaceModules!.push(AppInterfaceModule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppInterface {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterface();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterface"] = this.idAppInterface;
        data["name"] = this.name;
        data["website"] = this.website;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.appInterfaceRoles)) {
            data["appInterfaceRoles"] = [];
            for (let item of this.appInterfaceRoles)
                data["appInterfaceRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.appInterfaceModules)) {
            data["appInterfaceModules"] = [];
            for (let item of this.appInterfaceModules)
                data["appInterfaceModules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): AppInterface {
        const json = this.toJSON();
        let result = new AppInterface();
        result.init(json);
        return result;
    }
}

export class AppInterfaceModule extends AuditableEntity {
    idAppInterfaceModule?: number;
    idAppInterface?: number;
    orderId?: number;
    title?: string;
    appInterface?: AppInterface;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterfaceModule = _data["idAppInterfaceModule"];
            this.idAppInterface = _data["idAppInterface"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            this.appInterface = _data["appInterface"] ? AppInterface.fromJS(_data["appInterface"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppInterfaceModule {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceModule"] = this.idAppInterfaceModule;
        data["idAppInterface"] = this.idAppInterface;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        data["appInterface"] = this.appInterface ? this.appInterface.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): AppInterfaceModule {
        const json = this.toJSON();
        let result = new AppInterfaceModule();
        result.init(json);
        return result;
    }
}

export class AppInterfaceRoleAttr {
    idAppInterfaceRole?: number;
    appInterfaceRole?: AppInterfaceRole;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.appInterfaceRole = _data["appInterfaceRole"] ? AppInterfaceRole.fromJS(_data["appInterfaceRole"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): AppInterfaceRoleAttr {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceRoleAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["appInterfaceRole"] = this.appInterfaceRole ? this.appInterfaceRole.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): AppInterfaceRoleAttr {
        const json = this.toJSON();
        let result = new AppInterfaceRoleAttr();
        result.init(json);
        return result;
    }
}

export class AppInterfaceRoleVsAppInterfaceModule extends AuditableEntity {
    idAppInterfaceRole?: number;
    appInterfaceRole?: AppInterfaceRole;
    idAppInterfaceModule?: number;
    appInterfaceModule?: AppInterfaceModule;
    canManageConfigurations?: boolean;
    viewMode?: PermissionTypes;
    editMode?: PermissionTypes;
    deleteMode?: PermissionTypes;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.appInterfaceRole = _data["appInterfaceRole"] ? AppInterfaceRole.fromJS(_data["appInterfaceRole"]) : <any>undefined;
            this.idAppInterfaceModule = _data["idAppInterfaceModule"];
            this.appInterfaceModule = _data["appInterfaceModule"] ? AppInterfaceModule.fromJS(_data["appInterfaceModule"]) : <any>undefined;
            this.canManageConfigurations = _data["canManageConfigurations"];
            this.viewMode = _data["viewMode"];
            this.editMode = _data["editMode"];
            this.deleteMode = _data["deleteMode"];
        }
    }

    static fromJS(data: any): AppInterfaceRoleVsAppInterfaceModule {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceRoleVsAppInterfaceModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["appInterfaceRole"] = this.appInterfaceRole ? this.appInterfaceRole.toJSON() : <any>undefined;
        data["idAppInterfaceModule"] = this.idAppInterfaceModule;
        data["appInterfaceModule"] = this.appInterfaceModule ? this.appInterfaceModule.toJSON() : <any>undefined;
        data["canManageConfigurations"] = this.canManageConfigurations;
        data["viewMode"] = this.viewMode;
        data["editMode"] = this.editMode;
        data["deleteMode"] = this.deleteMode;
        super.toJSON(data);
        return data; 
    }

    clone(): AppInterfaceRoleVsAppInterfaceModule {
        const json = this.toJSON();
        let result = new AppInterfaceRoleVsAppInterfaceModule();
        result.init(json);
        return result;
    }
}

export enum PermissionTypes {
    None = 0,
    Mine = 1,
    Descendents = 2,
    All = 3,
}

export class Metadata extends AuditableEntity {
    idMetadataField?: number;
    metadataField?: MetadataField;
    value?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.metadataField = _data["metadataField"] ? MetadataField.fromJS(_data["metadataField"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Metadata {
        data = typeof data === 'object' ? data : {};
        let result = new Metadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["metadataField"] = this.metadataField ? this.metadataField.toJSON() : <any>undefined;
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }

    clone(): Metadata {
        const json = this.toJSON();
        let result = new Metadata();
        result.init(json);
        return result;
    }
}

export class UserMetadata extends Metadata {
    idUserMetadata?: number;
    idUser?: number;
    user?: User;
    userMetadataOptions?: UserMetadataOption[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserMetadata = _data["idUserMetadata"];
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["userMetadataOptions"])) {
                this.userMetadataOptions = [] as any;
                for (let item of _data["userMetadataOptions"])
                    this.userMetadataOptions!.push(UserMetadataOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new UserMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserMetadata"] = this.idUserMetadata;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.userMetadataOptions)) {
            data["userMetadataOptions"] = [];
            for (let item of this.userMetadataOptions)
                data["userMetadataOptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): UserMetadata {
        const json = this.toJSON();
        let result = new UserMetadata();
        result.init(json);
        return result;
    }
}

export class UserMetadataOption {
    idUserMetadata?: number;
    userMetadata?: UserMetadata;
    idMetadataFieldOption?: number;
    metadataFieldOption?: MetadataFieldOption;

    init(_data?: any) {
        if (_data) {
            this.idUserMetadata = _data["idUserMetadata"];
            this.userMetadata = _data["userMetadata"] ? UserMetadata.fromJS(_data["userMetadata"]) : <any>undefined;
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.metadataFieldOption = _data["metadataFieldOption"] ? MetadataFieldOption.fromJS(_data["metadataFieldOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserMetadataOption {
        data = typeof data === 'object' ? data : {};
        let result = new UserMetadataOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserMetadata"] = this.idUserMetadata;
        data["userMetadata"] = this.userMetadata ? this.userMetadata.toJSON() : <any>undefined;
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["metadataFieldOption"] = this.metadataFieldOption ? this.metadataFieldOption.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UserMetadataOption {
        const json = this.toJSON();
        let result = new UserMetadataOption();
        result.init(json);
        return result;
    }
}

export class UserComment extends AuditableEntity {
    idUserComment?: number;
    idUser?: number;
    user?: User;
    idUserRelated?: number | undefined;
    userRelated?: User | undefined;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserComment = _data["idUserComment"];
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.idUserRelated = _data["idUserRelated"];
            this.userRelated = _data["userRelated"] ? User.fromJS(_data["userRelated"]) : <any>undefined;
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): UserComment {
        data = typeof data === 'object' ? data : {};
        let result = new UserComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserComment"] = this.idUserComment;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["idUserRelated"] = this.idUserRelated;
        data["userRelated"] = this.userRelated ? this.userRelated.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        super.toJSON(data);
        return data; 
    }

    clone(): UserComment {
        const json = this.toJSON();
        let result = new UserComment();
        result.init(json);
        return result;
    }
}

export class UserLog extends AuditableEntity {
    idUserLog?: number;
    idUser?: number;
    user?: User;
    description?: string | undefined;
    typeId?: UserLogTypes;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLog = _data["idUserLog"];
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.description = _data["description"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): UserLog {
        data = typeof data === 'object' ? data : {};
        let result = new UserLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLog"] = this.idUserLog;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLog {
        const json = this.toJSON();
        let result = new UserLog();
        result.init(json);
        return result;
    }
}

export enum UserLogTypes {
    Created = 0,
    Edited = 1,
}

export class Feedback extends AuditableEntity {
    idFeedback?: number;
    idFeedbackType?: number | undefined;
    feedbackType?: FeedbackType | undefined;
    idUser?: number | undefined;
    user?: User | undefined;
    title?: string;
    description?: string | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    resolved?: boolean;
    feedbackQuestionGroups?: FeedbackQuestionGroup[];
    appGroupVsFeedbacks?: AppGroupVsFeedback[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedback = _data["idFeedback"];
            this.idFeedbackType = _data["idFeedbackType"];
            this.feedbackType = _data["feedbackType"] ? FeedbackType.fromJS(_data["feedbackType"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.resolved = _data["resolved"];
            if (Array.isArray(_data["feedbackQuestionGroups"])) {
                this.feedbackQuestionGroups = [] as any;
                for (let item of _data["feedbackQuestionGroups"])
                    this.feedbackQuestionGroups!.push(FeedbackQuestionGroup.fromJS(item));
            }
            if (Array.isArray(_data["appGroupVsFeedbacks"])) {
                this.appGroupVsFeedbacks = [] as any;
                for (let item of _data["appGroupVsFeedbacks"])
                    this.appGroupVsFeedbacks!.push(AppGroupVsFeedback.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Feedback {
        data = typeof data === 'object' ? data : {};
        let result = new Feedback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedback"] = this.idFeedback;
        data["idFeedbackType"] = this.idFeedbackType;
        data["feedbackType"] = this.feedbackType ? this.feedbackType.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["resolved"] = this.resolved;
        if (Array.isArray(this.feedbackQuestionGroups)) {
            data["feedbackQuestionGroups"] = [];
            for (let item of this.feedbackQuestionGroups)
                data["feedbackQuestionGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.appGroupVsFeedbacks)) {
            data["appGroupVsFeedbacks"] = [];
            for (let item of this.appGroupVsFeedbacks)
                data["appGroupVsFeedbacks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Feedback {
        const json = this.toJSON();
        let result = new Feedback();
        result.init(json);
        return result;
    }
}

export class FeedbackType extends AuditableEntity {
    idFeedbackType?: number;
    title?: string;
    icon?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackType = _data["idFeedbackType"];
            this.title = _data["title"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): FeedbackType {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackType"] = this.idFeedbackType;
        data["title"] = this.title;
        data["icon"] = this.icon;
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackType {
        const json = this.toJSON();
        let result = new FeedbackType();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionGroup extends AuditableEntity {
    idFeedbackQuestionGroup?: number;
    idFeedback?: number;
    feedback?: Feedback;
    title?: string;
    sendToStatistics?: boolean;
    reflection?: number;
    orderId?: number;
    feedbackQuestions?: FeedbackQuestion[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.title = _data["title"];
            this.sendToStatistics = _data["sendToStatistics"];
            this.reflection = _data["reflection"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["feedbackQuestions"])) {
                this.feedbackQuestions = [] as any;
                for (let item of _data["feedbackQuestions"])
                    this.feedbackQuestions!.push(FeedbackQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedbackQuestionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["sendToStatistics"] = this.sendToStatistics;
        data["reflection"] = this.reflection;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.feedbackQuestions)) {
            data["feedbackQuestions"] = [];
            for (let item of this.feedbackQuestions)
                data["feedbackQuestions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackQuestionGroup {
        const json = this.toJSON();
        let result = new FeedbackQuestionGroup();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestion extends AuditableEntity {
    idFeedbackQuestion?: number;
    idFeedbackQuestionGroup?: number;
    feedbackQuestionGroup?: FeedbackQuestionGroup;
    orderId?: number;
    idFeedbackQuestionType?: number;
    feedbackQuestionType?: FeedbackQuestionType;
    reflection?: number;
    title?: string;
    description?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.feedbackQuestionGroup = _data["feedbackQuestionGroup"] ? FeedbackQuestionGroup.fromJS(_data["feedbackQuestionGroup"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            this.feedbackQuestionType = _data["feedbackQuestionType"] ? FeedbackQuestionType.fromJS(_data["feedbackQuestionType"]) : <any>undefined;
            this.reflection = _data["reflection"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FeedbackQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["feedbackQuestionGroup"] = this.feedbackQuestionGroup ? this.feedbackQuestionGroup.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        data["feedbackQuestionType"] = this.feedbackQuestionType ? this.feedbackQuestionType.toJSON() : <any>undefined;
        data["reflection"] = this.reflection;
        data["title"] = this.title;
        data["description"] = this.description;
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackQuestion {
        const json = this.toJSON();
        let result = new FeedbackQuestion();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionType extends AuditableEntity {
    idFeedbackQuestionType?: number;
    feedbackQuestionTypeAttrs?: FeedbackQuestionTypeAttr[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            if (Array.isArray(_data["feedbackQuestionTypeAttrs"])) {
                this.feedbackQuestionTypeAttrs = [] as any;
                for (let item of _data["feedbackQuestionTypeAttrs"])
                    this.feedbackQuestionTypeAttrs!.push(FeedbackQuestionTypeAttr.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedbackQuestionType {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        if (Array.isArray(this.feedbackQuestionTypeAttrs)) {
            data["feedbackQuestionTypeAttrs"] = [];
            for (let item of this.feedbackQuestionTypeAttrs)
                data["feedbackQuestionTypeAttrs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackQuestionType {
        const json = this.toJSON();
        let result = new FeedbackQuestionType();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionTypeAttr {
    idFeedbackQuestionType?: number;
    feedbackQuestionType?: FeedbackQuestionType;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            this.feedbackQuestionType = _data["feedbackQuestionType"] ? FeedbackQuestionType.fromJS(_data["feedbackQuestionType"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): FeedbackQuestionTypeAttr {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionTypeAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        data["feedbackQuestionType"] = this.feedbackQuestionType ? this.feedbackQuestionType.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): FeedbackQuestionTypeAttr {
        const json = this.toJSON();
        let result = new FeedbackQuestionTypeAttr();
        result.init(json);
        return result;
    }
}

export class AppGroupVsFeedback extends AuditableEntity {
    idAppGroupVsFeedback?: number;
    idAppGroup?: number;
    appGroup?: AppGroup;
    idFeedback?: number;
    feedback?: Feedback;
    idUser?: number | undefined;
    user?: User | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppGroupVsFeedback = _data["idAppGroupVsFeedback"];
            this.idAppGroup = _data["idAppGroup"];
            this.appGroup = _data["appGroup"] ? AppGroup.fromJS(_data["appGroup"]) : <any>undefined;
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppGroupVsFeedback {
        data = typeof data === 'object' ? data : {};
        let result = new AppGroupVsFeedback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppGroupVsFeedback"] = this.idAppGroupVsFeedback;
        data["idAppGroup"] = this.idAppGroup;
        data["appGroup"] = this.appGroup ? this.appGroup.toJSON() : <any>undefined;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): AppGroupVsFeedback {
        const json = this.toJSON();
        let result = new AppGroupVsFeedback();
        result.init(json);
        return result;
    }
}

export class FeedbackVsUser extends AuditableEntity {
    idFeedbackVsUser?: number;
    idUser?: number;
    user?: User;
    idFeedback?: number;
    feedback?: Feedback;
    dateStart?: string;
    dateEnd?: string;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackVsUser = _data["idFeedbackVsUser"];
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
        }
    }

    static fromJS(data: any): FeedbackVsUser {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackVsUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackVsUser"] = this.idFeedbackVsUser;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackVsUser {
        const json = this.toJSON();
        let result = new FeedbackVsUser();
        result.init(json);
        return result;
    }
}

export class EntityComment extends AuditableEntity {
    idEntityComment?: number;
    idEntity?: number;
    entity?: Entity;
    idUser?: number | undefined;
    user?: User | undefined;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityComment = _data["idEntityComment"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): EntityComment {
        data = typeof data === 'object' ? data : {};
        let result = new EntityComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityComment"] = this.idEntityComment;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        super.toJSON(data);
        return data; 
    }

    clone(): EntityComment {
        const json = this.toJSON();
        let result = new EntityComment();
        result.init(json);
        return result;
    }
}

export class EntityLog extends AuditableEntity {
    idEntityLog?: number;
    idEntity?: number;
    entity?: Entity;
    description?: string | undefined;
    typeId?: EntityLogTypes;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityLog = _data["idEntityLog"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.description = _data["description"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): EntityLog {
        data = typeof data === 'object' ? data : {};
        let result = new EntityLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityLog"] = this.idEntityLog;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        super.toJSON(data);
        return data; 
    }

    clone(): EntityLog {
        const json = this.toJSON();
        let result = new EntityLog();
        result.init(json);
        return result;
    }
}

export enum EntityLogTypes {
    Created = 0,
    Edited = 1,
}

export class EntityMetadata extends Metadata {
    idEntityMetadata?: number;
    idEntity?: number;
    entity?: Entity;
    entityMetadataOptions?: EntityMetadataOption[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityMetadata = _data["idEntityMetadata"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            if (Array.isArray(_data["entityMetadataOptions"])) {
                this.entityMetadataOptions = [] as any;
                for (let item of _data["entityMetadataOptions"])
                    this.entityMetadataOptions!.push(EntityMetadataOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityMetadata"] = this.idEntityMetadata;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        if (Array.isArray(this.entityMetadataOptions)) {
            data["entityMetadataOptions"] = [];
            for (let item of this.entityMetadataOptions)
                data["entityMetadataOptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EntityMetadata {
        const json = this.toJSON();
        let result = new EntityMetadata();
        result.init(json);
        return result;
    }
}

export class EntityMetadataOption {
    idEntityMetadata?: number;
    entityMetadata?: EntityMetadata;
    idMetadataFieldOption?: number;
    metadataFieldOption?: MetadataFieldOption;

    init(_data?: any) {
        if (_data) {
            this.idEntityMetadata = _data["idEntityMetadata"];
            this.entityMetadata = _data["entityMetadata"] ? EntityMetadata.fromJS(_data["entityMetadata"]) : <any>undefined;
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.metadataFieldOption = _data["metadataFieldOption"] ? MetadataFieldOption.fromJS(_data["metadataFieldOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityMetadataOption {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetadataOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityMetadata"] = this.idEntityMetadata;
        data["entityMetadata"] = this.entityMetadata ? this.entityMetadata.toJSON() : <any>undefined;
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["metadataFieldOption"] = this.metadataFieldOption ? this.metadataFieldOption.toJSON() : <any>undefined;
        return data; 
    }

    clone(): EntityMetadataOption {
        const json = this.toJSON();
        let result = new EntityMetadataOption();
        result.init(json);
        return result;
    }
}

export class ActivityTagDto {
    idActivityTag?: number;
    name?: string;

    init(_data?: any) {
        if (_data) {
            this.idActivityTag = _data["idActivityTag"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActivityTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityTag"] = this.idActivityTag;
        data["name"] = this.name;
        return data; 
    }

    clone(): ActivityTagDto {
        const json = this.toJSON();
        let result = new ActivityTagDto();
        result.init(json);
        return result;
    }
}

export class ActivityFileDto {
    idActivity?: number;
    idActivityFile?: number;
    filename?: string;
    title?: string;
    isPublic?: boolean;
    dateCreated?: string;
    user?: UserBadgeDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.idActivityFile = _data["idActivityFile"];
            this.filename = _data["filename"];
            this.title = _data["title"];
            this.isPublic = _data["isPublic"];
            this.dateCreated = _data["dateCreated"];
            this.user = _data["user"] ? UserBadgeDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["idActivityFile"] = this.idActivityFile;
        data["filename"] = this.filename;
        data["title"] = this.title;
        data["isPublic"] = this.isPublic;
        data["dateCreated"] = this.dateCreated;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ActivityFileDto {
        const json = this.toJSON();
        let result = new ActivityFileDto();
        result.init(json);
        return result;
    }
}

export class ActivityLogtimeDto {
    idActivityLogtime?: number;
    idActivity?: number;
    idUser?: number | undefined;
    description?: string | undefined;
    dateStart?: string;
    dateEnd?: string;
    isBillable?: boolean;
    seconds?: number;

    init(_data?: any) {
        if (_data) {
            this.idActivityLogtime = _data["idActivityLogtime"];
            this.idActivity = _data["idActivity"];
            this.idUser = _data["idUser"];
            this.description = _data["description"];
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.isBillable = _data["isBillable"];
            this.seconds = _data["seconds"];
        }
    }

    static fromJS(data: any): ActivityLogtimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogtimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityLogtime"] = this.idActivityLogtime;
        data["idActivity"] = this.idActivity;
        data["idUser"] = this.idUser;
        data["description"] = this.description;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["isBillable"] = this.isBillable;
        data["seconds"] = this.seconds;
        return data; 
    }

    clone(): ActivityLogtimeDto {
        const json = this.toJSON();
        let result = new ActivityLogtimeDto();
        result.init(json);
        return result;
    }
}

export class MetadataConfigurationFieldSimple {
    idMetadataField?: number;
    value?: string | undefined;
    options?: number[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.value = _data["value"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): MetadataConfigurationFieldSimple {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataConfigurationFieldSimple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["value"] = this.value;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data; 
    }

    clone(): MetadataConfigurationFieldSimple {
        const json = this.toJSON();
        let result = new MetadataConfigurationFieldSimple();
        result.init(json);
        return result;
    }
}

export class ActivityLogtimeWorkDto {
    idActivity?: number;
    idUser?: number;
    isActive?: boolean;
    seconds?: number;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.idUser = _data["idUser"];
            this.isActive = _data["isActive"];
            this.seconds = _data["seconds"];
        }
    }

    static fromJS(data: any): ActivityLogtimeWorkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogtimeWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["idUser"] = this.idUser;
        data["isActive"] = this.isActive;
        data["seconds"] = this.seconds;
        return data; 
    }

    clone(): ActivityLogtimeWorkDto {
        const json = this.toJSON();
        let result = new ActivityLogtimeWorkDto();
        result.init(json);
        return result;
    }
}

export class ActivityStatisticsDto {
    audience?: number;
    comments?: number;
    files?: number;

    init(_data?: any) {
        if (_data) {
            this.audience = _data["audience"];
            this.comments = _data["comments"];
            this.files = _data["files"];
        }
    }

    static fromJS(data: any): ActivityStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["audience"] = this.audience;
        data["comments"] = this.comments;
        data["files"] = this.files;
        return data; 
    }

    clone(): ActivityStatisticsDto {
        const json = this.toJSON();
        let result = new ActivityStatisticsDto();
        result.init(json);
        return result;
    }
}

export class AppGroupDto {
    idAppGroup?: number;
    orderId?: number;
    name?: string;

    init(_data?: any) {
        if (_data) {
            this.idAppGroup = _data["idAppGroup"];
            this.orderId = _data["orderId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppGroup"] = this.idAppGroup;
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        return data; 
    }

    clone(): AppGroupDto {
        const json = this.toJSON();
        let result = new AppGroupDto();
        result.init(json);
        return result;
    }
}

export class AppInterfaceDto {
    idAppInterface?: number;
    name?: string;

    init(_data?: any) {
        if (_data) {
            this.idAppInterface = _data["idAppInterface"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppInterfaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterface"] = this.idAppInterface;
        data["name"] = this.name;
        return data; 
    }

    clone(): AppInterfaceDto {
        const json = this.toJSON();
        let result = new AppInterfaceDto();
        result.init(json);
        return result;
    }
}

export class AppInterfaceModuleDto {
    idAppInterfaceModule?: number;
    orderId?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idAppInterfaceModule = _data["idAppInterfaceModule"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): AppInterfaceModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceModule"] = this.idAppInterfaceModule;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        return data; 
    }

    clone(): AppInterfaceModuleDto {
        const json = this.toJSON();
        let result = new AppInterfaceModuleDto();
        result.init(json);
        return result;
    }
}

export class AppInterfaceRoleDto {
    idAppInterfaceRole?: number;
    idLanguage?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.idLanguage = _data["idLanguage"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): AppInterfaceRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["idLanguage"] = this.idLanguage;
        data["title"] = this.title;
        return data; 
    }

    clone(): AppInterfaceRoleDto {
        const json = this.toJSON();
        let result = new AppInterfaceRoleDto();
        result.init(json);
        return result;
    }
}

export abstract class DtosExtensions {

    init(_data?: any) {
    }

    static fromJS(data: any): DtosExtensions {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DtosExtensions' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): DtosExtensions {
        throw new Error("The abstract class 'DtosExtensions' cannot be instantiated.");
    }
}

export class EntityCommentDto {
    idEntity?: number;
    idEntityComment?: number;
    message?: string;
    isPublic?: number;
    idUser?: number;
    dateCreated?: string;
    user?: UserBadgeDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.idEntityComment = _data["idEntityComment"];
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
            this.idUser = _data["idUser"];
            this.dateCreated = _data["dateCreated"];
            this.user = _data["user"] ? UserBadgeDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["idEntityComment"] = this.idEntityComment;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        data["idUser"] = this.idUser;
        data["dateCreated"] = this.dateCreated;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): EntityCommentDto {
        const json = this.toJSON();
        let result = new EntityCommentDto();
        result.init(json);
        return result;
    }
}

export class EntityDto {
    idEntity?: number;
    idLanguage?: number;
    name?: string;
    fiscalIdNumber?: string;
    website?: string;
    notes?: string;
    photo?: string;
    isCompany?: boolean;
    idEntityGroup?: number | undefined;
    idEntityType?: number | undefined;
    entityGroup?: EntityGroupDto | undefined;
    entityType?: EntityTypeDto | undefined;
    metadata?: MetadataConfigurationFieldSimple[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.idLanguage = _data["idLanguage"];
            this.name = _data["name"];
            this.fiscalIdNumber = _data["fiscalIdNumber"];
            this.website = _data["website"];
            this.notes = _data["notes"];
            this.photo = _data["photo"];
            this.isCompany = _data["isCompany"];
            this.idEntityGroup = _data["idEntityGroup"];
            this.idEntityType = _data["idEntityType"];
            this.entityGroup = _data["entityGroup"] ? EntityGroupDto.fromJS(_data["entityGroup"]) : <any>undefined;
            this.entityType = _data["entityType"] ? EntityTypeDto.fromJS(_data["entityType"]) : <any>undefined;
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["idLanguage"] = this.idLanguage;
        data["name"] = this.name;
        data["fiscalIdNumber"] = this.fiscalIdNumber;
        data["website"] = this.website;
        data["notes"] = this.notes;
        data["photo"] = this.photo;
        data["isCompany"] = this.isCompany;
        data["idEntityGroup"] = this.idEntityGroup;
        data["idEntityType"] = this.idEntityType;
        data["entityGroup"] = this.entityGroup ? this.entityGroup.toJSON() : <any>undefined;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        return data; 
    }

    clone(): EntityDto {
        const json = this.toJSON();
        let result = new EntityDto();
        result.init(json);
        return result;
    }
}

export class EntityGroupDto {
    idEntityGroup?: number;
    idLanguage?: number;
    orderId?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idEntityGroup = _data["idEntityGroup"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityGroup"] = this.idEntityGroup;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntityGroupDto {
        const json = this.toJSON();
        let result = new EntityGroupDto();
        result.init(json);
        return result;
    }
}

export class EntityTypeDto {
    idEntityType?: number;
    idLanguage?: number;
    orderId?: number;
    title?: string;
    metadataGroups?: number[];

    init(_data?: any) {
        if (_data) {
            this.idEntityType = _data["idEntityType"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            if (Array.isArray(_data["metadataGroups"])) {
                this.metadataGroups = [] as any;
                for (let item of _data["metadataGroups"])
                    this.metadataGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): EntityTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityType"] = this.idEntityType;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        if (Array.isArray(this.metadataGroups)) {
            data["metadataGroups"] = [];
            for (let item of this.metadataGroups)
                data["metadataGroups"].push(item);
        }
        return data; 
    }

    clone(): EntityTypeDto {
        const json = this.toJSON();
        let result = new EntityTypeDto();
        result.init(json);
        return result;
    }
}

export class EntityFileDto {
    idEntity?: number;
    idEntityFile?: number;
    filename?: string;
    title?: string;
    isPublic?: boolean;
    dateCreated?: string;
    user?: UserBadgeDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.idEntityFile = _data["idEntityFile"];
            this.filename = _data["filename"];
            this.title = _data["title"];
            this.isPublic = _data["isPublic"];
            this.dateCreated = _data["dateCreated"];
            this.user = _data["user"] ? UserBadgeDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["idEntityFile"] = this.idEntityFile;
        data["filename"] = this.filename;
        data["title"] = this.title;
        data["isPublic"] = this.isPublic;
        data["dateCreated"] = this.dateCreated;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): EntityFileDto {
        const json = this.toJSON();
        let result = new EntityFileDto();
        result.init(json);
        return result;
    }
}

export class EntityLogDto {
    idEntity?: number;
    description?: string;
    typeId?: EntityLogTypes;
    dateCreated?: string;

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.description = _data["description"];
            this.typeId = _data["typeId"];
            this.dateCreated = _data["dateCreated"];
        }
    }

    static fromJS(data: any): EntityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        data["dateCreated"] = this.dateCreated;
        return data; 
    }

    clone(): EntityLogDto {
        const json = this.toJSON();
        let result = new EntityLogDto();
        result.init(json);
        return result;
    }
}

export class EntitySectorDto {
    idEntitySector?: number;
    idLanguage?: number;
    orderId?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idEntitySector = _data["idEntitySector"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntitySectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntitySectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntitySector"] = this.idEntitySector;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntitySectorDto {
        const json = this.toJSON();
        let result = new EntitySectorDto();
        result.init(json);
        return result;
    }
}

export class FeedbackAnswerDto {
    idFeedbackAnswer?: number;
    idFeedbackQuestion?: number | undefined;
    idFeedbackQuestionGroup?: number | undefined;
    idUser?: number | undefined;
    answer?: string;
    dateCreated?: string;
    idUserRequest?: string;
    idUserResponse?: string;
    idFeedbackType?: number;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackAnswer = _data["idFeedbackAnswer"];
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.idUser = _data["idUser"];
            this.answer = _data["answer"];
            this.idUserRequest = _data["idUserRequest"];
            this.idUserResponse = _data["idUserResponse"];
            this.idFeedbackType = _data["idFeedbackType"];
        }
    }

    static fromJS(data: any): FeedbackAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackAnswer"] = this.idFeedbackAnswer;
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["idUser"] = this.idUser;
        data["answer"] = this.answer;
        data["dateCreated"] = this.dateCreated;
        data["idUserRequest"] = this.idUserRequest;
        data["idUserResponse"] = this.idUserResponse;
        data["idFeedbackType"] = this.idFeedbackType;
        return data; 
    }

    clone(): FeedbackAnswerDto {
        const json = this.toJSON();
        let result = new FeedbackAnswerDto();
        result.init(json);
        return result;
    }
}

export class FeedbackCommentDto {
    idFeedbackComment?: number;
    idFeedback?: number;
    feedback?: Feedback;
    idUser?: number | undefined;
    user?: User | undefined;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackComment = _data["idFeedbackComment"];
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): FeedbackCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackComment"] = this.idFeedbackComment;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): FeedbackCommentDto {
        const json = this.toJSON();
        let result = new FeedbackCommentDto();
        result.init(json);
        return result;
    }
}

export class FeedbackDto {
    idFeedback?: number;
    idFeedbackType?: number | undefined;
    feedbackType?: FeedbackType | undefined;
    idUser?: number | undefined;
    user?: User | undefined;
    title?: string;
    description?: string | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    resolved?: boolean;
    feedbackQuestionGroups?: FeedbackQuestionGroup[] | undefined;
    appGroupVsFeedbacks?: AppGroupVsFeedback[] | undefined;
    selfEvaluationWeighted?: number | undefined;
    evaluatorEvaluationWeighted?: number | undefined;
    evaluation180Weighted?: number | undefined;
    teamEvaluationWeighted?: number | undefined;
    selfEvaluationDateEnd?: string | undefined;
    evaluatorEvaluationDateEnd?: string | undefined;
    evaluation180DateEnd?: string | undefined;
    idFeedback180?: number;

    init(_data?: any) {
        if (_data) {
            this.idFeedback = _data["idFeedback"];
            this.idFeedbackType = _data["idFeedbackType"];
            this.feedbackType = _data["feedbackType"] ? FeedbackType.fromJS(_data["feedbackType"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.resolved = _data["resolved"];
            this.selfEvaluationWeighted = _data["selfEvaluationWeighted"];
            this.evaluatorEvaluationWeighted = _data["evaluatorEvaluationWeighted"];
            this.evaluation180Weighted = _data["evaluation180Weighted"];
            this.teamEvaluationWeighted = _data["teamEvaluationWeighted"];
            this.selfEvaluationDateEnd = _data["selfEvaluationDateEnd"];
            this.evaluatorEvaluationDateEnd = _data["evaluatorEvaluationDateEnd"];
            this.evaluation180DateEnd = _data["evaluation180DateEnd"];
            this.idFeedback180 = _data["idFeedback180"];
            if (Array.isArray(_data["feedbackQuestionGroups"])) {
                this.feedbackQuestionGroups = [] as any;
                for (let item of _data["feedbackQuestionGroups"])
                    this.feedbackQuestionGroups!.push(FeedbackQuestionGroup.fromJS(item));
            }
            if (Array.isArray(_data["appGroupVsFeedbacks"])) {
                this.appGroupVsFeedbacks = [] as any;
                for (let item of _data["appGroupVsFeedbacks"])
                    this.appGroupVsFeedbacks!.push(AppGroupVsFeedback.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedback"] = this.idFeedback;
        data["idFeedbackType"] = this.idFeedbackType;
        data["feedbackType"] = this.feedbackType ? this.feedbackType.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["resolved"] = this.resolved;
        data["selfEvaluationWeighted"] = this.selfEvaluationWeighted;
        data["evaluatorEvaluationWeighted"] = this.evaluatorEvaluationWeighted;
        data["evaluation180Weighted"] = this.evaluation180Weighted;
        data["teamEvaluationWeighted"] = this.teamEvaluationWeighted;
        data["selfEvaluationDateEnd"] = this.selfEvaluationDateEnd;
        data["evaluatorEvaluationDateEnd"] = this.evaluatorEvaluationDateEnd;
        data["evaluation180DateEnd"] = this.evaluation180DateEnd;
        data["idFeedback180"] = this.idFeedback180;
        if (Array.isArray(this.feedbackQuestionGroups)) {
            data["feedbackQuestionGroups"] = [];
            for (let item of this.feedbackQuestionGroups)
                data["feedbackQuestionGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.appGroupVsFeedbacks)) {
            data["appGroupVsFeedbacks"] = [];
            for (let item of this.appGroupVsFeedbacks)
                data["appGroupVsFeedbacks"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FeedbackDto {
        const json = this.toJSON();
        let result = new FeedbackDto();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionDto {
    idFeedbackQuestion?: number;
    idFeedbackQuestionGroup?: number | undefined;
    feedbackQuestionGroup?: FeedbackQuestionGroup | undefined;
    idFeedback?: number | undefined;
    feedback?: Feedback | undefined;
    orderId?: number;
    idFeedbackQuestionType?: number;
    feedbackQuestionType?: FeedbackQuestionType | undefined;
    reflection?: number;
    title?: string;
    description?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.feedbackQuestionGroup = _data["feedbackQuestionGroup"] ? FeedbackQuestionGroup.fromJS(_data["feedbackQuestionGroup"]) : <any>undefined;
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            this.feedbackQuestionType = _data["feedbackQuestionType"] ? FeedbackQuestionType.fromJS(_data["feedbackQuestionType"]) : <any>undefined;
            this.reflection = _data["reflection"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FeedbackQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["feedbackQuestionGroup"] = this.feedbackQuestionGroup ? this.feedbackQuestionGroup.toJSON() : <any>undefined;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        data["feedbackQuestionType"] = this.feedbackQuestionType ? this.feedbackQuestionType.toJSON() : <any>undefined;
        data["reflection"] = this.reflection;
        data["title"] = this.title;
        data["description"] = this.description;
        return data; 
    }

    clone(): FeedbackQuestionDto {
        const json = this.toJSON();
        let result = new FeedbackQuestionDto();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionGroupDto {
    idFeedbackQuestionGroup?: number;
    idFeedback?: number | undefined;
    feedback?: Feedback | undefined;
    title?: string;
    sendToStatistics?: boolean;
    reflection?: number;
    orderId?: number;
    feedbackQuestions?: FeedbackQuestion[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.title = _data["title"];
            this.sendToStatistics = _data["sendToStatistics"];
            this.reflection = _data["reflection"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["feedbackQuestions"])) {
                this.feedbackQuestions = [] as any;
                for (let item of _data["feedbackQuestions"])
                    this.feedbackQuestions!.push(FeedbackQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedbackQuestionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["sendToStatistics"] = this.sendToStatistics;
        data["reflection"] = this.reflection;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.feedbackQuestions)) {
            data["feedbackQuestions"] = [];
            for (let item of this.feedbackQuestions)
                data["feedbackQuestions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FeedbackQuestionGroupDto {
        const json = this.toJSON();
        let result = new FeedbackQuestionGroupDto();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionTypeDto {
    idFeedbackQuestionType?: number;
    idLanguage?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            this.idLanguage = _data["idLanguage"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): FeedbackQuestionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        data["idLanguage"] = this.idLanguage;
        data["title"] = this.title;
        return data; 
    }

    clone(): FeedbackQuestionTypeDto {
        const json = this.toJSON();
        let result = new FeedbackQuestionTypeDto();
        result.init(json);
        return result;
    }
}

export class FeedbackStatsDto {
    comments?: number;
    recipients?: number;
    revisores?: number;
    questions?: number;
    percentageAnswered?: number;

    init(_data?: any) {
        if (_data) {
            this.comments = _data["comments"];
            this.recipients = _data["recipients"];
            this.revisores = _data["revisores"];
            this.questions = _data["questions"];
            this.percentageAnswered = _data["percentageAnswered"];
        }
    }

    static fromJS(data: any): FeedbackStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        data["recipients"] = this.recipients;
        data["revisores"] = this.revisores;
        data["questions"] = this.questions;
        data["percentageAnswered"] = this.percentageAnswered;
        return data; 
    }

    clone(): FeedbackStatsDto {
        const json = this.toJSON();
        let result = new FeedbackStatsDto();
        result.init(json);
        return result;
    }
}

export class FeedbackTypeDto {
    idFeedbackType?: number;
    title?: string;
    icon?: string;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackType = _data["idFeedbackType"];
            this.title = _data["title"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): FeedbackTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackType"] = this.idFeedbackType;
        data["title"] = this.title;
        data["icon"] = this.icon;
        return data; 
    }

    clone(): FeedbackTypeDto {
        const json = this.toJSON();
        let result = new FeedbackTypeDto();
        result.init(json);
        return result;
    }
}

export class FeedbackVsUser180Dto {
    idFeedbackVsUser180?: number;
    idFeedback?: number | undefined;
    idUserRequest?: number | undefined;
    idUserResponse?: number | undefined;
    dateCreated?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackVsUser180 = _data["idFeedbackVsUser180"];
            this.idFeedback = _data["idFeedback"];
            this.idUserRequest = _data["idUserRequest"];
            this.idUserResponse = _data["idUserResponse"];
            this.dateCreated = _data["dateCreated"];
        }
    }

    static fromJS(data: any): FeedbackVsUser180Dto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackVsUser180Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackVsUser180"] = this.idFeedbackVsUser180;
        data["idFeedback"] = this.idFeedback;
        data["idUserRequest"] = this.idUserRequest;
        data["idUserResponse"] = this.idUserResponse;
        data["dateCreated"] = this.dateCreated;
        return data; 
    }

    clone(): FeedbackVsUser180Dto {
        const json = this.toJSON();
        let result = new FeedbackVsUser180Dto();
        result.init(json);
        return result;
    }
}

export class LanguageDto {
    idLanguage?: number;
    name?: string;
    code?: string;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }

    clone(): LanguageDto {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}

export class MetadataConfiguration {
    groups?: MetadataConfigurationGroup[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(MetadataConfigurationGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MetadataConfiguration {
        const json = this.toJSON();
        let result = new MetadataConfiguration();
        result.init(json);
        return result;
    }
}

export class MetadataConfigurationGroup {
    idMetadataGroup?: number;
    title?: string;
    fields?: MetadataConfigurationField[];

    init(_data?: any) {
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.title = _data["title"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(MetadataConfigurationField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataConfigurationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataConfigurationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["title"] = this.title;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MetadataConfigurationGroup {
        const json = this.toJSON();
        let result = new MetadataConfigurationGroup();
        result.init(json);
        return result;
    }
}

export class MetadataConfigurationField extends MetadataConfigurationFieldSimple {
    title?: string | undefined;
    reference?: string | undefined;
    default?: string | undefined;
    photo?: string | undefined;
    validation?: string | undefined;
    isRequired?: boolean;
    type?: MetadataFieldTypes | undefined;
    optionsAvailable?: MetadataConfigurationFieldOption[] | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.reference = _data["reference"];
            this.default = _data["default"];
            this.photo = _data["photo"];
            this.validation = _data["validation"];
            this.isRequired = _data["isRequired"];
            this.type = _data["type"];
            if (Array.isArray(_data["optionsAvailable"])) {
                this.optionsAvailable = [] as any;
                for (let item of _data["optionsAvailable"])
                    this.optionsAvailable!.push(MetadataConfigurationFieldOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataConfigurationField {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataConfigurationField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["reference"] = this.reference;
        data["default"] = this.default;
        data["photo"] = this.photo;
        data["validation"] = this.validation;
        data["isRequired"] = this.isRequired;
        data["type"] = this.type;
        if (Array.isArray(this.optionsAvailable)) {
            data["optionsAvailable"] = [];
            for (let item of this.optionsAvailable)
                data["optionsAvailable"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): MetadataConfigurationField {
        const json = this.toJSON();
        let result = new MetadataConfigurationField();
        result.init(json);
        return result;
    }
}

export class MetadataConfigurationFieldOption {
    idMetadataFieldOption?: number;
    title?: string;
    photo?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.title = _data["title"];
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): MetadataConfigurationFieldOption {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataConfigurationFieldOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["title"] = this.title;
        data["photo"] = this.photo;
        return data; 
    }

    clone(): MetadataConfigurationFieldOption {
        const json = this.toJSON();
        let result = new MetadataConfigurationFieldOption();
        result.init(json);
        return result;
    }
}

export class MetadataConfigurationComposer {
    configuration?: MetadataConfiguration;
    metadata?: MetadataConfigurationFieldSimple[];

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"] ? MetadataConfiguration.fromJS(_data["configuration"]) : <any>undefined;
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataConfigurationComposer {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataConfigurationComposer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MetadataConfigurationComposer {
        const json = this.toJSON();
        let result = new MetadataConfigurationComposer();
        result.init(json);
        return result;
    }
}

export class MetadataFieldDto {
    idMetadataField?: number;
    idMetadataGroup?: number;
    idLanguage?: number;
    reference?: string;
    orderId?: number;
    title?: string;
    default?: string | undefined;
    photo?: string | undefined;
    typeId?: number;
    isRequired?: boolean;
    validation?: string;
    description?: string;

    init(_data?: any) {
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.idLanguage = _data["idLanguage"];
            this.reference = _data["reference"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            this.default = _data["default"];
            this.photo = _data["photo"];
            this.typeId = _data["typeId"];
            this.isRequired = _data["isRequired"];
            this.validation = _data["validation"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MetadataFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["idLanguage"] = this.idLanguage;
        data["reference"] = this.reference;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        data["default"] = this.default;
        data["photo"] = this.photo;
        data["typeId"] = this.typeId;
        data["isRequired"] = this.isRequired;
        data["validation"] = this.validation;
        data["description"] = this.description;
        return data; 
    }

    clone(): MetadataFieldDto {
        const json = this.toJSON();
        let result = new MetadataFieldDto();
        result.init(json);
        return result;
    }
}

export class MetadataFieldOptionDto {
    idMetadataFieldOption?: number;
    idLanguage?: number;
    orderId?: number;
    idMetadataField?: number;
    title?: string;
    photo?: string;

    init(_data?: any) {
        if (_data) {
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.idMetadataField = _data["idMetadataField"];
            this.title = _data["title"];
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): MetadataFieldOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["idMetadataField"] = this.idMetadataField;
        data["title"] = this.title;
        data["photo"] = this.photo;
        return data; 
    }

    clone(): MetadataFieldOptionDto {
        const json = this.toJSON();
        let result = new MetadataFieldOptionDto();
        result.init(json);
        return result;
    }
}

export class MetadataFilter {
    idMetadataField?: number;
    isOptions?: boolean;
    values?: string[];
    valuesInteger?: number[];

    init(_data?: any) {
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.isOptions = _data["isOptions"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["valuesInteger"])) {
                this.valuesInteger = [] as any;
                for (let item of _data["valuesInteger"])
                    this.valuesInteger!.push(item);
            }
        }
    }

    static fromJS(data: any): MetadataFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["isOptions"] = this.isOptions;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.valuesInteger)) {
            data["valuesInteger"] = [];
            for (let item of this.valuesInteger)
                data["valuesInteger"].push(item);
        }
        return data; 
    }

    clone(): MetadataFilter {
        const json = this.toJSON();
        let result = new MetadataFilter();
        result.init(json);
        return result;
    }
}

export class MetadataGroupDto {
    idMetadataGroup?: number;
    idLanguage?: number;
    orderId?: number;
    title?: string;
    visibleOnCreate?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            this.visibleOnCreate = _data["visibleOnCreate"];
        }
    }

    static fromJS(data: any): MetadataGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        data["visibleOnCreate"] = this.visibleOnCreate;
        return data; 
    }

    clone(): MetadataGroupDto {
        const json = this.toJSON();
        let result = new MetadataGroupDto();
        result.init(json);
        return result;
    }
}

export class SearchResultDto {
    id?: number;
    title?: string;
    description?: string;
    group?: string;
    icon?: string | undefined;
    url?: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.group = _data["group"];
            this.icon = _data["icon"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["group"] = this.group;
        data["icon"] = this.icon;
        data["url"] = this.url;
        return data; 
    }

    clone(): SearchResultDto {
        const json = this.toJSON();
        let result = new SearchResultDto();
        result.init(json);
        return result;
    }
}

export class UserCommentDto {
    idUser?: number;
    idUserComment?: number;
    message?: string;
    isPublic?: number;
    idUserRelated?: number | undefined;
    dateCreated?: string;
    userRelated?: UserBadgeDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.idUserComment = _data["idUserComment"];
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
            this.idUserRelated = _data["idUserRelated"];
            this.dateCreated = _data["dateCreated"];
            this.userRelated = _data["userRelated"] ? UserBadgeDto.fromJS(_data["userRelated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["idUserComment"] = this.idUserComment;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        data["idUserRelated"] = this.idUserRelated;
        data["dateCreated"] = this.dateCreated;
        data["userRelated"] = this.userRelated ? this.userRelated.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UserCommentDto {
        const json = this.toJSON();
        let result = new UserCommentDto();
        result.init(json);
        return result;
    }
}

export class UserDto {
    idUser?: number;
    idLanguage?: number;
    name?: string;
    email?: string;
    contactDefault?: string;
    contactOptional?: string;
    photo?: string;
    nationality?: string | undefined;
    dateBirth?: string | undefined;
    idParent?: number | undefined;
    parent?: UserBadgeDto | undefined;
    idEntity?: number | undefined;
    entity?: EntityDto | undefined;
    idUserType?: number | undefined;
    userType?: UserTypeDto | undefined;
    metadata?: MetadataConfigurationFieldSimple[] | undefined;
    appGroups?: AppGroup[];

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.idLanguage = _data["idLanguage"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.contactDefault = _data["contactDefault"];
            this.contactOptional = _data["contactOptional"];
            this.photo = _data["photo"];
            this.nationality = _data["nationality"];
            this.dateBirth = _data["dateBirth"];
            this.idParent = _data["idParent"];
            this.parent = _data["parent"] ? UserBadgeDto.fromJS(_data["parent"]) : <any>undefined;
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? EntityDto.fromJS(_data["entity"]) : <any>undefined;
            this.idUserType = _data["idUserType"];
            this.userType = _data["userType"] ? UserTypeDto.fromJS(_data["userType"]) : <any>undefined;
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
            if (Array.isArray(_data["appGroups"])) {
                this.appGroups = [] as any;
                for (let item of _data["appGroups"])
                    this.appGroups!.push(AppGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["idLanguage"] = this.idLanguage;
        data["name"] = this.name;
        data["email"] = this.email;
        data["contactDefault"] = this.contactDefault;
        data["contactOptional"] = this.contactOptional;
        data["photo"] = this.photo;
        data["nationality"] = this.nationality;
        data["dateBirth"] = this.dateBirth;
        data["idParent"] = this.idParent;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["idUserType"] = this.idUserType;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>undefined;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        if (Array.isArray(this.appGroups)) {
            data["appGroups"] = [];
            for (let item of this.appGroups)
                data["appGroups"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export class UserTypeDto {
    idUserType?: number;
    idLanguage?: number;
    orderId?: number;
    title?: string;
    metadataGroups?: number[];

    init(_data?: any) {
        if (_data) {
            this.idUserType = _data["idUserType"];
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            if (Array.isArray(_data["metadataGroups"])) {
                this.metadataGroups = [] as any;
                for (let item of _data["metadataGroups"])
                    this.metadataGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): UserTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserType"] = this.idUserType;
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        if (Array.isArray(this.metadataGroups)) {
            data["metadataGroups"] = [];
            for (let item of this.metadataGroups)
                data["metadataGroups"].push(item);
        }
        return data; 
    }

    clone(): UserTypeDto {
        const json = this.toJSON();
        let result = new UserTypeDto();
        result.init(json);
        return result;
    }
}

export class UserLogDto {
    idUser?: number;
    description?: string;
    typeId?: UserLogTypes;
    dateCreated?: string;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.description = _data["description"];
            this.typeId = _data["typeId"];
            this.dateCreated = _data["dateCreated"];
        }
    }

    static fromJS(data: any): UserLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        data["dateCreated"] = this.dateCreated;
        return data; 
    }

    clone(): UserLogDto {
        const json = this.toJSON();
        let result = new UserLogDto();
        result.init(json);
        return result;
    }
}

export class UserLoginAccessDto {
    idAppInterfaceRole?: number;
    isActive?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserLoginAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): UserLoginAccessDto {
        const json = this.toJSON();
        let result = new UserLoginAccessDto();
        result.init(json);
        return result;
    }
}

export class UserLoginDto {
    idUser?: number;
    idUserLogin?: number;
    username?: string;
    password?: string;
    isRecovering?: boolean;
    dateCreated?: string;
    groups?: AppGroupDto[] | undefined;
    accesses?: UserLoginAccessDto[] | undefined;
    interfaces?: AppInterfaceDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.idUserLogin = _data["idUserLogin"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.isRecovering = _data["isRecovering"];
            this.dateCreated = _data["dateCreated"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(AppGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["accesses"])) {
                this.accesses = [] as any;
                for (let item of _data["accesses"])
                    this.accesses!.push(UserLoginAccessDto.fromJS(item));
            }
            if (Array.isArray(_data["interfaces"])) {
                this.interfaces = [] as any;
                for (let item of _data["interfaces"])
                    this.interfaces!.push(AppInterfaceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["idUserLogin"] = this.idUserLogin;
        data["username"] = this.username;
        data["password"] = this.password;
        data["isRecovering"] = this.isRecovering;
        data["dateCreated"] = this.dateCreated;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.accesses)) {
            data["accesses"] = [];
            for (let item of this.accesses)
                data["accesses"].push(item.toJSON());
        }
        if (Array.isArray(this.interfaces)) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserLoginDto {
        const json = this.toJSON();
        let result = new UserLoginDto();
        result.init(json);
        return result;
    }
}

export enum ActivityLogTypes {
    Created = 0,
    Edited = 1,
    TagsEdited = 2,
    StatusChanged = 3,
    LogTimeStarted = 4,
    LogTimeEnded = 5,
}